import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-seo-title',
  templateUrl: './seo-title.component.html',
  styleUrls: ['./seo-title.component.css']
})
export class SeoTitleComponent implements OnInit {

  @Input("seoTitleInput") seoTitle;

  constructor() { }

  ngOnInit() {
  }

}
